export default "__VITE_ASSET__D_C$_ndX__"